import React from 'react';
import { motion } from 'framer-motion';
import { clayStaggerContainer, clayStaggerItem } from '../../constants/animations';
import { MachhaCharacter } from '../../lib/machhaAsset';
import styles from './ErrorPageLayout.module.css';

type CharacterState =
  | 'Confirmation' | 'Empty' | 'Error' | 'Failure' | 'Forbidden'
  | 'Loading' | 'Maintanance' | 'Milestone' | 'Not Found' | 'Offline'
  | 'Onboarding' | 'Rate Limit' | 'Success' | 'Warning' | 'Welcome';

interface ErrorPageLayoutProps {
  characterState: CharacterState;
  heading?: string;
  title?: string;
  description?: string;
  cta?: React.ReactNode;
  characterSize?: number;
}

export function ErrorPageLayout({
  characterState = 'Error',
  heading,
  title,
  description,
  cta,
  characterSize = 160,
}: ErrorPageLayoutProps) {
  return (
    <motion.div
      className={styles.root}
      variants={clayStaggerContainer}
      initial="hidden"
      animate="visible"
    >
      <motion.div className={styles.character} variants={clayStaggerItem}>
        <MachhaCharacter state={characterState} size={characterSize} />
      </motion.div>

      {heading && (
        <motion.h1 className={styles.heading} variants={clayStaggerItem}>
          {heading}
        </motion.h1>
      )}

      {title && (
        <motion.p className={styles.title} variants={clayStaggerItem}>
          {title}
        </motion.p>
      )}

      {description && (
        <motion.p className={styles.description} variants={clayStaggerItem}>
          {description}
        </motion.p>
      )}

      {cta && (
        <motion.div className={styles.cta} variants={clayStaggerItem}>
          {cta}
        </motion.div>
      )}
    </motion.div>
  );
}
